import React, { Component } from "react";
import "../../static/css/styles.css";

let currentYear = new Date().getFullYear();
class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="text-center">
            <a
              data-content="contact@saayahealth.com"
              href="mailto:contact@saayahealth.com"
              data-type="mail"
              className="footer-text-a"
            >
              contact@saayahealth.com
            </a>
          </div>
          <div className="text-center">
            <label className="footer-text">
              Whatsapp Customer Support - 0097335317168
            </label>
          </div>
          <div className="text-center">
            <label className="footer-text">
              Copyright &copy; Saaya Health {currentYear}
            </label>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js